"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxeAccountType = void 0;
var AxeAccountType;
(function (AxeAccountType) {
    AxeAccountType["ANNUITY_ANNUITIZED"] = "ANNUITY_ANNUITIZED";
    AxeAccountType["ANNUITY_GENERAL"] = "ANNUITY_GENERAL";
    AxeAccountType["ANNUITY_VARIABLE"] = "ANNUITY_VARIABLE";
    AxeAccountType["ASSET_BUSINESS_OWNERSHIP"] = "ASSET_BUSINESS_OWNERSHIP";
    AxeAccountType["ASSET_OTHER"] = "ASSET_OTHER";
    AxeAccountType["ATTORNEY_IN_FACT"] = "ATTORNEY_IN_FACT";
    AxeAccountType["AUDIT"] = "AUDIT";
    AxeAccountType["BANK_CASH_MANAGEMENT"] = "BANK_CASH_MANAGEMENT";
    AxeAccountType["BANK_CD"] = "BANK_CD";
    AxeAccountType["BANK_DEBIT"] = "BANK_DEBIT";
    AxeAccountType["BANK_SAVINGS"] = "BANK_SAVINGS";
    AxeAccountType["BROKERAGE_CASH"] = "BROKERAGE_CASH";
    AxeAccountType["BROKERAGE_MARGIN"] = "BROKERAGE_MARGIN";
    AxeAccountType["COMMON_TRUST_TAX_DEFERRED"] = "COMMON_TRUST_TAX_DEFERRED";
    AxeAccountType["COMMON_TRUST_TAXABLE"] = "COMMON_TRUST_TAXABLE";
    AxeAccountType["CUSTODIAL_OTHER"] = "CUSTODIAL_OTHER";
    AxeAccountType["CUSTODIAL_UGMA_UTMA"] = "CUSTODIAL_UGMA_UTMA";
    AxeAccountType["DB_CURRENT"] = "DB_CURRENT";
    AxeAccountType["DB_FORMER"] = "DB_FORMER";
    AxeAccountType["DC_CURRENT"] = "DC_CURRENT";
    AxeAccountType["DC_FORMER"] = "DC_FORMER";
    AxeAccountType["DEBT_AUTO"] = "DEBT_AUTO";
    AxeAccountType["DEBT_CREDIT_CARD"] = "DEBT_CREDIT_CARD";
    AxeAccountType["DEBT_CREDIT_LINE"] = "DEBT_CREDIT_LINE";
    AxeAccountType["DEBT_EDUCATION"] = "DEBT_EDUCATION";
    AxeAccountType["DEBT_HOME"] = "DEBT_HOME";
    AxeAccountType["DEBT_LOAN"] = "DEBT_LOAN";
    AxeAccountType["DEBT_OTHER"] = "DEBT_OTHER";
    AxeAccountType["DEBT_TAXES_DUE"] = "DEBT_TAXES_DUE";
    AxeAccountType["DEFERRED_PROFIT_SHARING_PLAN"] = "DEFERRED_PROFIT_SHARING_PLAN";
    AxeAccountType["EDUCATION_529"] = "EDUCATION_529";
    AxeAccountType["EDUCATION_COVERDELL"] = "EDUCATION_COVERDELL";
    AxeAccountType["EDUCATION_OTHER"] = "EDUCATION_OTHER";
    AxeAccountType["EMPLOYER_401K"] = "EMPLOYER_401K";
    AxeAccountType["EMPLOYER_401K_ROTH"] = "EMPLOYER_401K_ROTH";
    AxeAccountType["EMPLOYER_403B"] = "EMPLOYER_403B";
    AxeAccountType["EMPLOYER_403B_NONERISA"] = "EMPLOYER_403B_NONERISA";
    AxeAccountType["EMPLOYER_403B_ROTH"] = "EMPLOYER_403B_ROTH";
    AxeAccountType["EMPLOYER_BROKERAGE"] = "EMPLOYER_BROKERAGE";
    AxeAccountType["EMPLOYER_DEFERRED_COMPENSATION"] = "EMPLOYER_DEFERRED_COMPENSATION";
    AxeAccountType["EMPLOYER_EMPLOYEE_BENEFIT"] = "EMPLOYER_EMPLOYEE_BENEFIT";
    AxeAccountType["EMPLOYER_EMPLOYEE_OWNERSHIP"] = "EMPLOYER_EMPLOYEE_OWNERSHIP";
    AxeAccountType["EMPLOYER_FSA"] = "EMPLOYER_FSA";
    AxeAccountType["EMPLOYER_HRA"] = "EMPLOYER_HRA";
    AxeAccountType["EMPLOYER_HSA"] = "EMPLOYER_HSA";
    AxeAccountType["EMPLOYER_MPP"] = "EMPLOYER_MPP";
    AxeAccountType["EMPLOYER_OTHER"] = "EMPLOYER_OTHER";
    AxeAccountType["EMPLOYER_PENSION"] = "EMPLOYER_PENSION";
    AxeAccountType["EMPLOYER_PR"] = "EMPLOYER_PR";
    AxeAccountType["EPFO"] = "EPFO";
    AxeAccountType["EPS"] = "EPS";
    AxeAccountType["ESOP_UK"] = "ESOP_UK";
    AxeAccountType["ESTATE"] = "ESTATE";
    AxeAccountType["GENERAL_ACCOUNT"] = "GENERAL_ACCOUNT";
    AxeAccountType["GIC"] = "GIC";
    AxeAccountType["IF_LIFE"] = "IF_LIFE";
    AxeAccountType["IF_LOCKED_IN"] = "IF_LOCKED_IN";
    AxeAccountType["IF_PRESCRIBED_RETIREMENT"] = "IF_PRESCRIBED_RETIREMENT";
    AxeAccountType["IF_RETIREMENT"] = "IF_RETIREMENT";
    AxeAccountType["IF_SPOUSAL_RETIREMENT"] = "IF_SPOUSAL_RETIREMENT";
    AxeAccountType["INDIVIDUAL"] = "INDIVIDUAL";
    AxeAccountType["INSURANCE_AUTO"] = "INSURANCE_AUTO";
    AxeAccountType["INSURANCE_HEALTH"] = "INSURANCE_HEALTH";
    AxeAccountType["INSURANCE_HOME"] = "INSURANCE_HOME";
    AxeAccountType["INSURANCE_LIFE"] = "INSURANCE_LIFE";
    AxeAccountType["INSURANCE_TRAVEL"] = "INSURANCE_TRAVEL";
    AxeAccountType["INVALID"] = "INVALID";
    AxeAccountType["IRA_INHERITED_ROTH"] = "IRA_INHERITED_ROTH";
    AxeAccountType["IRA_INHERITED_TRADITIONAL"] = "IRA_INHERITED_TRADITIONAL";
    AxeAccountType["IRA_INHERITED_TRUST"] = "IRA_INHERITED_TRUST";
    AxeAccountType["IRA_ROLLOVER"] = "IRA_ROLLOVER";
    AxeAccountType["IRA_ROTH"] = "IRA_ROTH";
    AxeAccountType["IRA_SEP"] = "IRA_SEP";
    AxeAccountType["IRA_SIMPLE"] = "IRA_SIMPLE";
    AxeAccountType["IRA_TRADITIONAL"] = "IRA_TRADITIONAL";
    AxeAccountType["ISA"] = "ISA";
    AxeAccountType["ISA_CASH"] = "ISA_CASH";
    AxeAccountType["ISA_INNOVATIVE_FINANCE"] = "ISA_INNOVATIVE_FINANCE";
    AxeAccountType["ISA_JUNIOR"] = "ISA_JUNIOR";
    AxeAccountType["ISA_LIFETIME"] = "ISA_LIFETIME";
    AxeAccountType["ISA_OTHER"] = "ISA_OTHER";
    AxeAccountType["ISA_STOCK"] = "ISA_STOCK";
    AxeAccountType["JOINT_COMMUNITY_PROPERTY"] = "JOINT_COMMUNITY_PROPERTY";
    AxeAccountType["JOINT_TENANTS_BY_ENTIRETY"] = "JOINT_TENANTS_BY_ENTIRETY";
    AxeAccountType["JOINT_TIC"] = "JOINT_TIC";
    AxeAccountType["JOINT_TWROS"] = "JOINT_TWROS";
    AxeAccountType["LIRA"] = "LIRA";
    AxeAccountType["NPS"] = "NPS";
    AxeAccountType["ORG_501C"] = "ORG_501C";
    AxeAccountType["ORG_BANK"] = "ORG_BANK";
    AxeAccountType["ORG_BROKER_DEALER"] = "ORG_BROKER_DEALER";
    AxeAccountType["ORG_CHURCH"] = "ORG_CHURCH";
    AxeAccountType["ORG_CORPORATION"] = "ORG_CORPORATION";
    AxeAccountType["ORG_ENDOWMENT"] = "ORG_ENDOWMENT";
    AxeAccountType["ORG_ESCROW"] = "ORG_ESCROW";
    AxeAccountType["ORG_EXEMPT"] = "ORG_EXEMPT";
    AxeAccountType["ORG_FIDUCIARY"] = "ORG_FIDUCIARY";
    AxeAccountType["ORG_FOUNDATION"] = "ORG_FOUNDATION";
    AxeAccountType["ORG_HOSPITAL"] = "ORG_HOSPITAL";
    AxeAccountType["ORG_INVESTMENT_CLUB"] = "ORG_INVESTMENT_CLUB";
    AxeAccountType["ORG_OTHER"] = "ORG_OTHER";
    AxeAccountType["ORG_PARTNERSHIP"] = "ORG_PARTNERSHIP";
    AxeAccountType["ORG_PROFESSIONAL_ASSOCIATION"] = "ORG_PROFESSIONAL_ASSOCIATION";
    AxeAccountType["ORG_SCHOOL"] = "ORG_SCHOOL";
    AxeAccountType["ORG_SOLE_PROPRIETOR"] = "ORG_SOLE_PROPRIETOR";
    AxeAccountType["PENSION_CASH"] = "PENSION_CASH";
    AxeAccountType["PPF"] = "PPF";
    AxeAccountType["PROPERTY_PERSONAL_AUTO"] = "PROPERTY_PERSONAL_AUTO";
    AxeAccountType["PROPERTY_PERSONAL_HOUSEHOLD_FURNISHINGS"] = "PROPERTY_PERSONAL_HOUSEHOLD_FURNISHINGS";
    AxeAccountType["PROPERTY_PERSONAL_OTHER"] = "PROPERTY_PERSONAL_OTHER";
    AxeAccountType["PROPERTY_PERSONAL_VALUABLES"] = "PROPERTY_PERSONAL_VALUABLES";
    AxeAccountType["PROPERTY_REAL_ESTATE_HOME"] = "PROPERTY_REAL_ESTATE_HOME";
    AxeAccountType["PROPERTY_REAL_ESTATE_OTHER"] = "PROPERTY_REAL_ESTATE_OTHER";
    AxeAccountType["RPP"] = "RPP";
    AxeAccountType["SBS_I401K"] = "SBS_I401K";
    AxeAccountType["SBS_I401K_ROTH"] = "SBS_I401K_ROTH";
    AxeAccountType["SBS_KEOGH"] = "SBS_KEOGH";
    AxeAccountType["SBS_VRIP"] = "SBS_VRIP";
    AxeAccountType["SIPP"] = "SIPP";
    AxeAccountType["SIPP_DRAWDOWN"] = "SIPP_DRAWDOWN";
    AxeAccountType["SPECIAL_CHARITABLE_GIFT_ACCOUNT"] = "SPECIAL_CHARITABLE_GIFT_ACCOUNT";
    AxeAccountType["SPECIAL_MANAGED"] = "SPECIAL_MANAGED";
    AxeAccountType["SPECIAL_PRECIOUS_METALS"] = "SPECIAL_PRECIOUS_METALS";
    AxeAccountType["SPECIAL_RESTRICTED_STOCK"] = "SPECIAL_RESTRICTED_STOCK";
    AxeAccountType["SP_DISABILITY"] = "SP_DISABILITY";
    AxeAccountType["SP_EDUCATION"] = "SP_EDUCATION";
    AxeAccountType["SP_GROUP_RETIREMENT"] = "SP_GROUP_RETIREMENT";
    AxeAccountType["SP_LOCKED_IN_RETIREMENT"] = "SP_LOCKED_IN_RETIREMENT";
    AxeAccountType["SP_NONREGISTERED"] = "SP_NONREGISTERED";
    AxeAccountType["SP_RESTRICTED_LOCKED_IN"] = "SP_RESTRICTED_LOCKED_IN";
    AxeAccountType["SP_RETIREMENT"] = "SP_RETIREMENT";
    AxeAccountType["SP_SPOUSAL_RETIREMENT"] = "SP_SPOUSAL_RETIREMENT";
    AxeAccountType["SUPERANNUATION"] = "SUPERANNUATION";
    AxeAccountType["TFSA"] = "TFSA";
    AxeAccountType["TRUST"] = "TRUST";
    AxeAccountType["TRUST_CLT"] = "TRUST_CLT";
    AxeAccountType["TRUST_CRT"] = "TRUST_CRT";
    AxeAccountType["TRUST_GRAT"] = "TRUST_GRAT";
    AxeAccountType["TRUST_GRIT"] = "TRUST_GRIT";
    AxeAccountType["TRUST_ILIT"] = "TRUST_ILIT";
    AxeAccountType["TRUST_INTERNATIONAL"] = "TRUST_INTERNATIONAL";
    AxeAccountType["TRUST_IRREVOCABLE"] = "TRUST_IRREVOCABLE";
    AxeAccountType["TRUST_LIFE_INTEREST"] = "TRUST_LIFE_INTEREST";
    AxeAccountType["TRUST_LIVING_TRUST"] = "TRUST_LIVING_TRUST";
    AxeAccountType["TRUST_REVOCABLE"] = "TRUST_REVOCABLE";
    AxeAccountType["TRUST_UNDER_WILL"] = "TRUST_UNDER_WILL";
    AxeAccountType["UNKNOWN"] = "UNKNOWN";
})(AxeAccountType = exports.AxeAccountType || (exports.AxeAccountType = {}));
